(function () {
  const REVIEWS_PAGE_SIZE = 10;

  const parseI18n = (root) => {
    const node = root.querySelector('[data-home-reviews-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const formatDate = (iso) => {
    if (!iso) {
      return '';
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const cloneStarIcon = (root, isEmpty) => {
    const template = root.querySelector('[data-home-reviews-star-template]');
    if (!template || !template.content.firstElementChild) {
      return null;
    }
    const star = template.content.firstElementChild.cloneNode(true);
    if (isEmpty) {
      star.classList.add('is-empty');
    }
    return star;
  };

  const buildStars = (rating, root) => {
    const value = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    const wrap = document.createElement('div');
    wrap.className = 'home-reviews__stars-wrap';
    wrap.setAttribute('aria-label', `${value}/5`);

    const row = document.createElement('span');
    row.className = 'home-reviews__stars';
    for (let index = 1; index <= 5; index += 1) {
      const star = cloneStarIcon(root, index > value);
      if (star) {
        row.appendChild(star);
      }
    }

    wrap.appendChild(row);
    return wrap;
  };

  const sortComments = (items, mode) => {
    const list = items.slice();
    list.sort((a, b) => {
      const timeA = new Date(a.commentDate || a.createdAt).getTime();
      const timeB = new Date(b.commentDate || b.createdAt).getTime();
      const ratingA = Number(a.rating) || 0;
      const ratingB = Number(b.rating) || 0;

      if (mode === 'oldest') {
        return timeA - timeB;
      }
      if (mode === 'rating_desc') {
        return ratingB - ratingA || timeB - timeA;
      }
      if (mode === 'rating_asc') {
        return ratingA - ratingB || timeB - timeA;
      }
      return timeB - timeA;
    });
    return list;
  };

  const filterComments = (items, query, ratingFilter) => {
    const normalizedQuery = query.trim().toLowerCase();
    return items.filter((item) => {
      const rating = Number(item.rating) || 0;
      if (ratingFilter !== null && rating !== ratingFilter) {
        return false;
      }
      if (!normalizedQuery) {
        return true;
      }
      const parts = [item.body, item.displayName, item.productTitle]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return parts.includes(normalizedQuery);
    });
  };

  const countByRating = (items) => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    items.forEach((item) => {
      const rating = Math.round(Number(item.rating) || 0);
      if (rating >= 1 && rating <= 5) {
        counts[rating] += 1;
      }
    });
    return counts;
  };

  const createCard = (comment, i18n, root) => {
    const card = document.createElement('article');
    card.className = 'home-reviews__card';

    const head = document.createElement('div');
    head.className = 'home-reviews__card-head';

    const name = document.createElement('div');
    name.className = 'home-reviews__card-name';
    name.textContent = comment.displayName || i18n.guestName || '';

    head.appendChild(name);
    head.appendChild(buildStars(comment.rating, root));
    card.appendChild(head);

    const body = document.createElement('div');
    body.className = 'home-reviews__card-body';
    body.textContent = comment.body || '';
    card.appendChild(body);

    const foot = document.createElement('div');
    foot.className = 'home-reviews__card-foot';

    const date = document.createElement('time');
    date.className = 'home-reviews__card-date';
    date.dateTime = comment.commentDate || comment.createdAt || '';
    if (comment.displayDate) {
      date.textContent = comment.displayDate;
    } else {
      date.textContent = formatDate(comment.commentDate || comment.createdAt);
    }
    foot.appendChild(date);

    card.appendChild(foot);
    return card;
  };

  const initSection = (root) => {
    if (root.dataset.homeReviewsInitialized === 'true') {
      return;
    }

    const apiBase = root.dataset.homeReviewsApi || 'https://joker-baby-shopify-app.vercel.app';
    const shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(root.dataset.homeReviewsShop)
        : String(root.dataset.homeReviewsShop || '').trim().toLowerCase();
    const configuredLimit = Number(root.dataset.homeReviewsLimit) || 50;
    const fetchLimit = Math.min(50, Math.max(4, configuredLimit));
    const i18n = parseI18n(root);

    const statusEl = root.querySelector('[data-home-reviews-status]');
    const gridEl = root.querySelector('[data-home-reviews-grid]');
    const searchEl = root.querySelector('[data-home-reviews-search]');
    const sortEl = root.querySelector('[data-home-reviews-sort]');
    const filtersEl = root.querySelector('[data-home-reviews-rating-filters]');
    const moreWrapEl = root.querySelector('[data-home-reviews-more]');
    const moreBtnEl = root.querySelector('[data-home-reviews-more-btn]');

    if (!gridEl || !apiBase || !shop) {
      return;
    }

    let allComments = [];
    let activeRating = null;
    let visibleCount = REVIEWS_PAGE_SIZE;

    const setStatus = (message, visible) => {
      if (!statusEl) {
        return;
      }
      statusEl.textContent = message || '';
      statusEl.hidden = !visible;
    };

    const renderRatingFilters = () => {
      if (!filtersEl) {
        return;
      }
      const counts = countByRating(allComments);
      filtersEl.innerHTML = '';

      for (let rating = 1; rating <= 5; rating += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'home-reviews__rating-btn';
        if (activeRating === rating) {
          button.classList.add('is-active');
        }
        button.dataset.rating = String(rating);

        const num = document.createElement('strong');
        num.className = 'home-reviews__rating-num';
        num.textContent = String(rating);

        const starWrap = document.createElement('span');
        starWrap.className = 'home-reviews__rating-btn-star';
        const filterStar = cloneStarIcon(root, false);
        if (filterStar) {
          starWrap.appendChild(filterStar);
        }

        const count = document.createElement('span');
        count.className = 'home-reviews__rating-count';
        count.textContent = `(${counts[rating]})`;

        button.appendChild(num);
        button.appendChild(starWrap);
        button.appendChild(count);

        const label = i18n.ratingFilter || '';
        if (label) {
          button.setAttribute('aria-label', `${label} ${rating}`);
        }
        filtersEl.appendChild(button);
      }
    };

    const setMoreVisible = (show) => {
      if (!moreWrapEl) {
        return;
      }
      moreWrapEl.hidden = !show;
    };

    const getFilteredComments = () => {
      const query = searchEl ? searchEl.value : '';
      let sortMode = sortEl ? sortEl.value : '';
      if (!sortMode) {
        sortMode = 'newest';
      }
      let visible = filterComments(allComments, query, activeRating);
      visible = sortComments(visible, sortMode);
      return visible;
    };

    const renderGrid = (options) => {
      const append = options && options.append === true;
      const filtered = getFilteredComments();

      if (allComments.length === 0) {
        gridEl.innerHTML = '';
        setMoreVisible(false);
        setStatus(i18n.empty || '', true);
        return;
      }

      if (filtered.length === 0) {
        gridEl.innerHTML = '';
        setMoreVisible(false);
        setStatus(i18n.emptyFiltered || '', true);
        return;
      }

      setStatus('', false);

      let batch = [];
      if (!append) {
        visibleCount = Math.min(REVIEWS_PAGE_SIZE, filtered.length);
        gridEl.innerHTML = '';
        batch = filtered.slice(0, visibleCount);
      } else {
        const previousCount = visibleCount;
        visibleCount = Math.min(visibleCount + REVIEWS_PAGE_SIZE, filtered.length);
        batch = filtered.slice(previousCount, visibleCount);
      }

      batch.forEach((comment) => {
        gridEl.appendChild(createCard(comment, i18n, root));
      });

      setMoreVisible(filtered.length > visibleCount);
    };

    const resetVisibleBatch = () => {
      visibleCount = REVIEWS_PAGE_SIZE;
      renderGrid({ append: false });
    };

    const bindControls = () => {
      if (searchEl) {
        searchEl.addEventListener('input', () => {
          resetVisibleBatch();
        });
      }

      if (sortEl) {
        sortEl.addEventListener('change', () => {
          resetVisibleBatch();
        });
      }

      if (filtersEl) {
        filtersEl.addEventListener('click', (event) => {
          const target = event.target.closest('[data-rating]');
          if (!target) {
            return;
          }
          const rating = Number(target.dataset.rating);
          if (activeRating === rating) {
            activeRating = null;
          } else {
            activeRating = rating;
          }
          renderRatingFilters();
          resetVisibleBatch();
        });
      }

      if (moreBtnEl) {
        if (i18n.showMore) {
          moreBtnEl.textContent = i18n.showMore;
        }
        moreBtnEl.addEventListener('click', () => {
          renderGrid({ append: true });
        });
      }
    };

    const loadComments = async () => {
      setStatus(i18n.loading || '', true);
      gridEl.innerHTML = '';

      const url = `${apiBase.replace(/\/$/, '')}/api/storefront/homepage-comments?shop=${encodeURIComponent(shop)}&limit=${encodeURIComponent(String(fetchLimit))}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('fetch failed');
        }
        const payload = await response.json();
        allComments = Array.isArray(payload.comments) ? payload.comments : [];
        renderRatingFilters();
        renderGrid();
      } catch (error) {
        allComments = [];
        gridEl.innerHTML = '';
        setStatus(i18n.loadError || '', true);
      }
    };

    bindControls();
    loadComments();
    root.dataset.homeReviewsInitialized = 'true';
  };

  const init = () => {
    document.querySelectorAll('[data-home-reviews]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-home-reviews]');
    if (section) {
      section.dataset.homeReviewsInitialized = 'false';
      initSection(section);
    }
  });
})();
